import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col h-full bg-white" }
const _hoisted_2 = { class: "md:mx-56 mb-48" }
const _hoisted_3 = { class: "max-w-5xl mx-auto" }
const _hoisted_4 = { class: "p-2" }
const _hoisted_5 = { class: "text-xl font-bold" }
const _hoisted_6 = { class: "text-xs" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h1", { class: "m-2 text-xl font-bold" }, "Choix de la prestation", -1)

import {onMounted } from 'vue'
  import Categories from "@/components/Company/Categories.vue" 
  import Carousel from "@/components/Company/Carousel.vue" 
  import { storeToRefs } from 'pinia'
  import { useCurrentCompanyStore } from '../stores/CurrentCompanyStore'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyPage',
  props: {
        id: {
          type: Number,
          required: true,
        }
  },
  setup(__props) {

const props = __props;

  const {currentCompanyId,companyName,addressLine1,addressLine2,city,country,zipCode,items, openHours, photoUrlList} = storeToRefs(useCurrentCompanyStore())
  
  
  const {getEvents, getCompanyById } = useCurrentCompanyStore()

  onMounted( () => {
    getCompanyById(props.id);
    getEvents(props.id);
    // getCompanyById(currentCompanyId.value);
    // getEvents(currentCompanyId.value);
  })
  
 
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(companyName)), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(addressLine1)) + ", " + _toDisplayString(_unref(zipCode)) + " " + _toDisplayString(_unref(city)) + ", " + _toDisplayString(_unref(country)), 1)
        ]),
        _createVNode(Carousel, { photoUrl: _unref(photoUrlList) }, null, 8, ["photoUrl"]),
        _hoisted_7,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items), (it) => {
          return (_openBlock(), _createBlock(Categories, {
            key: it.categorie,
            categorie: it.categorie,
            subitems: it.subItems
          }, null, 8, ["categorie", "subitems"]))
        }), 128))
      ])
    ])
  ]))
}
}

})